import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, makePaginationItemSx, makePaginationNavSx, paginationFooterSx } from '../css/revenueItems.styles';

const PaymentsPagination = ({ pagination, paginationItems, paginationLabel, onPageChange }) => (
  <Box sx={paginationFooterSx}>
    <Typography sx={{ color: colors.textSecondary, fontSize: '0.85rem' }}>{paginationLabel}</Typography>

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        onClick={() => pagination.page > 1 && onPageChange(pagination.page - 1)}
        sx={makePaginationNavSx(pagination.page > 1)}
      >
        {'<'}
      </Box>

      {paginationItems.map((item, index) => (
        <Box
          key={`${item}-${index}`}
          onClick={() => typeof item === 'number' && onPageChange(item)}
          sx={makePaginationItemSx(item === pagination.page, item === '...')}
        >
          {item}
        </Box>
      ))}

      <Box
        onClick={() => pagination.page < pagination.totalPages && onPageChange(pagination.page + 1)}
        sx={makePaginationNavSx(pagination.page < pagination.totalPages)}
      >
        {'>'}
      </Box>
    </Box>
  </Box>
);

export default PaymentsPagination;
